import { ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip, Typography } from "@mui/material"
import { LogoutSharp } from "@mui-symbols-material/w300"
import type { FC, MouseEvent } from "react"
import { useState } from "react"

import { getCollapsedNavItemTextSx } from "./styles"

import { Avatar } from "@/components/common/Avatar"
import type { CurrentUser } from "@/graphql/codegen/graphql"
import { useAuthStore } from "@/stores/authStore"
import { stringAvatar } from "@/utils/utils"

interface SideNavUserInfoProps {
  currentUser: CurrentUser | null
  isCollapsed: boolean
}

export const SideNavUserInfo: FC<SideNavUserInfoProps> = ({ currentUser, isCollapsed }) => {
  const store = useAuthStore.getState()
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null)

  const handleLogOut = async () => {
    await store.signOut()
    setAnchorElUser(null)
  }

  const handleOpenUserMenu = (e: MouseEvent<HTMLElement>) => {
    setAnchorElUser(e.currentTarget)
  }

  if (!currentUser) return null

  return (
    <>
      <Tooltip title={isCollapsed ? currentUser.name : ""} placement='right'>
        <ListItemButton
          className='rounded'
          onClick={handleOpenUserMenu}
          data-testid='sidenav-user-menu-button'
          sx={isCollapsed ? { justifyContent: "center" } : undefined}
        >
          <ListItemIcon className='flex min-w-6 items-center justify-center'>
            <Avatar
              alt={currentUser.name}
              src={currentUser.avatarUrl ?? ""}
              size={32}
              {...stringAvatar(currentUser.name)}
            />
          </ListItemIcon>
          <ListItemText primary={currentUser.name} sx={getCollapsedNavItemTextSx(isCollapsed)} />
        </ListItemButton>
      </Tooltip>

      <Menu
        sx={{ mt: "10px" }}
        id='sidenav-user-menu'
        anchorEl={anchorElUser}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        MenuListProps={{
          ...(anchorElUser && { sx: { width: anchorElUser.offsetWidth, minWidth: 150 } }),
        }}
        open={Boolean(anchorElUser)}
        onClose={() => setAnchorElUser(null)}
      >
        <MenuItem className='hover:bg-primary-100' onClick={handleLogOut}>
          <LogoutSharp className='text-gray-600' />
          <Typography className='ml-2.5 text-gray-800'>Log Out</Typography>
        </MenuItem>
      </Menu>
    </>
  )
}
